"use strict"

import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import {injectIntl, FormattedMessage} from "react-intl"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"

import {Grid, Paper, Container, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsButton from "../../global/ui/xsButton/xsButton"

import {isPasswordValid} from "../../global/helpers/functions"

import GlobalStore from "../../global/store/GlobalStore"
import RouterStore from "../../global/store/RouterStore"
import LoginStore from "./loginStore"

function ResetPasswordContainer() {
	const hooks = {
		onSubmit(form) {
			const {password, conf_psw} = form.values()

			if (isNotEmpty(password) && password != conf_psw) {
				GlobalStore.setNotificationMessage("Heslo a potvrdenie hesla sa musia zhodovať!", "", "warning")
				form.$("password").invalidate()
			} else if (!isPasswordValid(password) || !isPasswordValid(conf_psw)) {
				GlobalStore.setNotificationMessage(
					"Heslo musí obsahovať veľké aj malé písmená, jeden špeciálny znak a aspoň jedno číslo. Dĺžka hesla musí byť minimálne 8 znakov.",
					"",
					"warning"
				)
				form.$("password").invalidate()
			}
		},
		onSuccess(form) {
			LoginStore.resetPasswordFinish(form)
		},
		onError() {
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia!", "", "warning")
		}
	}

	const [showPassword, setShowPassword] = useState(false)
	const [showConfPassword, setShowConfPassword] = useState(false)

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					password: {
						label: "Nové heslo"
					},
					conf_psw: {
						label: "Potvrdenie hesla"
					}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	useEffect(() => {
		LoginStore.token = new URLSearchParams(RouterStore.location.search).get("token")
	}, [])

	return (
		<React.Fragment>
			<div className="main_header">
				<Container style={{maxWidth: "90%"}}>
					<Grid container alignItems="center" justify="space-between" className="pt-2 pb-2">
						<Grid item>
							<div>
								<img
									src="/public/images/logo_siea_blue.png"
									style={{paddingBottom: "22px", paddingRight: "16px"}}
									className="pointer"
									onClick={() => RouterStore.push("/login")}
								/>
								<img
									src="/public/images/logo_inovujme_backoffice.png"
									style={{width: "100px", height: "100px"}}
									className="pointer"
									onClick={() => RouterStore.push("/login")}
								/>
							</div>
						</Grid>
						<Grid item style={{width: 368}}></Grid>
					</Grid>
				</Container>
			</div>
			<Container maxWidth="lg">
				<Grid container justify="center">
					<Grid item style={{maxWidth: "400px", width: "400px"}}>
						<Grid container direction="column" justify="center" style={{height: "65vh"}}>
							<Paper variant="elevation" elevation={2} style={{backgroundColor: "transparent"}}>
								<Box p={2}>
									<Grid item container direction="column" spacing={2}>
										<Grid item class="header_gradient">
											<Typography variant="h4" style={{textAlign: "center", paddingTop: "8px", paddingBottom: "8px"}}>
												Reset hesla
											</Typography>
										</Grid>
										<Grid item>
											<Typography variant="subtitle2">Heslo musí spĺňať nasledovné kritériá:</Typography>
											<ul style={{paddingInlineStart: "20px"}}>
												<li>musí obsahovať aspoň jedno VEĽKÉ písmeno</li>
												<li>musí obsahovať aspoň jedno malé písmeno</li>
												<li>musí obsahovať aspoň jedno číslo</li>
												<li>musí obsahovať aspoň jeden špeciálny znak</li>
												<li>dĺžka hesla musí byť minimálne 8 znakov a maximálne 50 znakov</li>
											</ul>
											<Typography variant="body2">
												Môžete si vytvoriť vlastné heslo alebo si ho nechať vygenerovať prehliadačom.
											</Typography>
										</Grid>
										<Grid item>
											<XsInput
												regex={(val) => isPasswordValid(val)}
												autoComplete="new-password"
												field={form.$("password")}
												autoFocus={true}
												submitAction={(e) => form.onSubmit(e)}
												type={showPassword ? "text" : "password"}
												customEndAdornment={
													<i
														className={showPassword ? "far fa-eye-slash" : "far fa-eye"}
														onClick={() => {
															setShowPassword(!showPassword)
														}}
													></i>
												}
											/>
										</Grid>
										<Grid item>
											<XsInput
												regex={(val) => isPasswordValid(val)}
												autoComplete="new-password"
												field={form.$("conf_psw")}
												submitAction={(e) => form.onSubmit(e)}
												type={showConfPassword ? "text" : "password"}
												customEndAdornment={
													<i
														className={showConfPassword ? "far fa-eye-slash" : "far fa-eye"}
														onClick={() => {
															setShowConfPassword(!showConfPassword)
														}}
													></i>
												}
											/>
										</Grid>
										<Grid item>
											<XsButton text={<FormattedMessage id="Common.label.resetPsw" />} onClick={form.onSubmit} />
										</Grid>
										<Grid item>
											<Link
												variant="body2"
												className="pointer"
												onClick={() => {
													LoginStore.screen = LoginStore.screens.LOGIN
													RouterStore.push("./login")
												}}
											>
												Prihlásiť sa
											</Link>
										</Grid>
									</Grid>
								</Box>
							</Paper>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</React.Fragment>
	)
}

export default injectIntl(observer(ResetPasswordContainer))

